import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=6ee656a6&scoped=true"
import script from "./product_detail.vue?vue&type=script&lang=ts"
export * from "./product_detail.vue?vue&type=script&lang=ts"
import style0 from "./product_detail.vue?vue&type=style&index=0&id=6ee656a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee656a6",
  null
  
)

export default component.exports